import auth from '@/api/auth';
import device from '@/api/device';
import groups from '@/api/groups';
import events from '@/api/events';
import terms from '@/api/terms-and-conditions';
import report from '@/api/report';

export default {
    auth,
    device,
    groups,
    events,
    terms,
    report,
};
